import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";
import {
  PLATFORM_SET_CLOSED,
  usePlatformDispatch,
} from "@platform/PlatformContext";

export function useFetchPlatformClosedStatus() {
  const dispatch = usePlatformDispatch();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["platform-closed-status"],
    queryFn: async () => {
      return await apiRequest(
        `/api/system-variable/isPlatformClosed/`,
        "GET",
        null,
        false // Don't require auth
      );
    },
    retry: false,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });

  useEffect(() => {
    if (data?.value !== undefined) {
      // Parse the value - it might be a string "true"/"false" or boolean
      const isPlatformClosed =
        typeof data.value === "string"
          ? data.value.toLowerCase() === "true"
          : Boolean(data.value);

      dispatch({
        type: PLATFORM_SET_CLOSED,
        payload: isPlatformClosed,
      });
    }
  }, [data, dispatch]);

  // If there's an error fetching, keep the default (true)
  useEffect(() => {
    if (isError) {
      console.warn("Failed to fetch platform closed status, using default");
    }
  }, [isError]);

  return { isLoading };
}

export default useFetchPlatformClosedStatus;
